// src/utils/booking.js

export const initCal = () => {
  // Check if Cal exists on the window object
  if (typeof window.Cal !== "function") {
    console.warn("Cal.com script not yet loaded, retrying in 500ms...");
    setTimeout(initCal, 500); // Retry until it exists
    return;
  }

  // Now that we know window.Cal exists, initialize it
  window.Cal("init", "infratier-30min", {
    origin: "https://cal.com",
  });
};

export const openBookingModal = () => {
  if (window.Cal) {
    window.Cal("modal", {
      calLink: "infra-tier",
    });
  } else {
    // Fallback if still not loaded
    window.open("https://cal.com/infra-tier", "_blank");
  }
};